import React,{useState} from 'react'
import {Row,Col} from 'react-bootstrap'
import MobileInputSubComp from './sub_components/MobileInputSubComp'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { optionsClass, optionssession } from '../../Helper'
import { preOAssignTeacherforsubApi } from '../../../utils/AdminDashApi/PreOStudentSubjectApi'

const PreOAssignTeacherForSubjectsCompmb = () => {
  const [drpsession, setdrpsession] = useState("")
  const [myclass, setclass] = useState("")
  const [sessionmod1err, setsessionmod1err] = useState("")
  const [sessionmod1label, setsessionmod1label] = useState("")
  const drpfuncsession = (myval, myid) => {
    setdrpsession(myval)
}
const drpfuncclass = (myval, myid) => {
    setclass(myval)
}
  return (
    <>
      <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
          <div className="mobilecontainer">
            <div className="adminmbheading">
              <h3>Assign Teacher for Subjects</h3>
            </div>
            <div className="admbwrap pb0">
              <Row>
                <MobileInputSubComp col="6" direct="left" name="Session">
                  <div className="dropdownwrapper">
                    <Dropdown2 err={sessionmod1err === "err" ? "err" : ""} func={drpfuncsession} myplaceholder="Select" fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssession} />
                  </div>
                  <label>{sessionmod1label}</label>
                </MobileInputSubComp>
                <MobileInputSubComp col="6" direct="right" name="Class">
                  <div className="dropdownwrapper">
                    <Dropdown2 err={false} func={drpfuncclass} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsClass} />
                  </div>

                </MobileInputSubComp>
              </Row>
            </div>
            <div className="admbwrap">
              <div className="tablewrapscroll">
              <div className="tablewrapscroll">
                            <div className="flexvaluetable classSectionEntrytable">
                            <table>
                            <thead>
                                <tr>
                                    {
                                    preOAssignTeacherforsubApi.heading.map((item,key)=>{
                                        return(
                                        <th key={key}> <div>{item.head}</div> </th>
                                        )
                                    })
                                    }
                                </tr>
                            </thead>
                            
                       
                          <tbody>
                        {
                            preOAssignTeacherforsubApi.data.map((item,key)=>{
                                return(
                                    <>
                                    
                                    <tr>
                                    
                                      <td>{item.sl}</td>
                                      <td>{item.subjectname}</td>
                                      <td>{item.teachername}</td>
                                      <td>{item.teacherperventage}</td>
                                      <td>{item.vat}</td>
                                      
                                    </tr>
                                  
                                    </>
                                  )
                            })
                            }
                        </tbody>                        
                      
                      </table>
                            </div>
                            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PreOAssignTeacherForSubjectsCompmb